var React = require('react');

function Spark (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M14.1072 1.05581C14.5088 1.19591 14.7778 1.57469 14.7778 2V8.69231H20C20.3838 8.69231 20.7337 8.91196 20.9006 9.25759C21.0674 9.60322 21.0217 10.0138 20.783 10.3143L11.0052 22.622C10.7407 22.9551 10.2944 23.0843 9.89283 22.9442C9.49125 22.8041 9.22223 22.4253 9.22223 22V15.3077H4.00001C3.61622 15.3077 3.26628 15.088 3.09944 14.7424C2.9326 14.3968 2.97829 13.9862 3.21702 13.6857L12.9948 1.37796C13.2594 1.04495 13.7056 0.915712 14.1072 1.05581ZM6.07161 13.3077H10.2222C10.7745 13.3077 11.2222 13.7554 11.2222 14.3077V19.1336L17.9284 10.6923H13.7778C13.2255 10.6923 12.7778 10.2446 12.7778 9.69231V4.86636L6.07161 13.3077Z","fill":"currentColor"}));
}

Spark.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none"};

module.exports = Spark;

Spark.default = Spark;
